import React from 'react'

// styles
import { WrapPopupShowFinger } from './index.styles'

// images
import icCloseGray from "../../../../../../../images/ic_close_gray.svg";

// constant
import { dataFingerPrint } from '../../../../../../../data/infosType';

// api
import { apiFingerHistory } from '../../../../../../../actions/supervisorAction/biometricAction';

// helper
import getChannelName from '../../../../../../../helper/getChannelName';

const PopupShowFinger = ({ dataFinger, handleClose }) => {

    if (!dataFinger)
        return null
    return (
        <WrapPopupShowFinger>
            <div className="wrap-header">
                <div>{dataFingerPrint[dataFinger.BioType].label}</div>
                <img src={icCloseGray} alt="close" onClick={handleClose} />
            </div>
            <div className="channel">Kênh tác nghiệp: {getChannelName(dataFinger.fromChannel)}</div>
            <div className="wrap-content">
                {
                    dataFinger.EnrollData.map(fingerId => (
                        <div className="wrap-finger" key={fingerId}>
                            <img src={apiFingerHistory(fingerId)} alt="finger" />
                        </div>
                    ))
                }
            </div>
            <div className="wrap-footer">
                <label htmlFor="active">
                    <input
                        type="radio"
                        id="active"
                        name="status"
                        defaultChecked={dataFinger.IsActive && dataFinger.IsConfirmFinger}
                        onClick={e => e.preventDefault()}
                    />
                    Hoạt động
                </label>
                <label htmlFor="closed">
                    <input
                        type="radio"
                        id="closed"
                        name="status"
                        defaultChecked={!dataFinger.IsActive && !dataFinger.IsConfirmFinger}
                        onClick={e => e.preventDefault()}
                    />
                    Đóng
                </label>
                <label htmlFor="hang">
                    <input
                        type="radio"
                        id="hang"
                        name="status"
                        defaultChecked={!dataFinger.IsActive && dataFinger.IsConfirmFinger}
                        onClick={e => e.preventDefault()}
                    />
                    Treo vân tay giao dịch
                </label>
            </div>
        </WrapPopupShowFinger>
    )
}

export default PopupShowFinger
